import apiClient from './api';
import type { NotificationsPage, NotificationsQuery } from '@/types/notification.types';

export async function listNotifications(query: NotificationsQuery): Promise<NotificationsPage> {
  const params: Record<string, string | number | boolean> = {};
  if (query.unreadOnly) params.unread_only = true;
  if (query.limit !== undefined) params.limit = query.limit;
  if (query.before) params.before = query.before;
  const response = await apiClient.get<NotificationsPage>('/api/notifications', { params });
  return response.data;
}

export async function markNotificationRead(notificationId: string): Promise<void> {
  await apiClient.post(`/api/notifications/${encodeURIComponent(notificationId)}/read`);
}

export async function markAllNotificationsRead(): Promise<void> {
  await apiClient.post('/api/notifications/read-all');
}
